import React, { Component, Fragment } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import TableDop from './lineTableDop';
import FavouriteStar from '../favouriteStar/';
import { numberFormat, getIdFromSlug } from '../../common';

@inject('accountStore')
@observer
class NumberGames extends Component {
  render () {
    if (!this.props.accountStore.accountSettings.gamesNumber && this.props.mode) return null;
    return <div className="g-n" dangerouslySetInnerHTML={ {__html: '#' + this.props.number} }></div>;
  }
}

@inject('accountStore', 'lineStore', 'dictStore')
@observer
class Toogle extends Component {
  state = {
    showTooltip: this.props.showTooltip
  };

  tooltipRef = React.createRef();

  componentDidMount () {
    if (this.props.showTooltip) {
      document.addEventListener('click', this.handleClickOutside, false);
      this.props.accountStore.toggleAccountSettings('tooltip_union_stat_match', 1);
    }
  }

  componentWillUnmount () {
    this.props.showTooltip && document.removeEventListener('click', this.handleClickOutside, false);
  }

  handleClickOutside = e => {
    if (e.path && !e.path.includes(this.tooltipRef.current)) {
      this.handleClose();
    }
  };

  handleClose = () => {
    document.removeEventListener('click', this.handleClickOutside, false);
    this.setState({showTooltip: false});
  };

  rossToogle = () => {
    this.props.lineStore.line.toogleShowDop(this.props.id, 1);
  }

  render () {
    const {
      getLang
    } = this.props.dictStore;
    const {
      sr,
      ross,
      ross_stats_count,
    } = this.props.lineStore.line.lineGames.get(this.props.id);
    const rossForView = Number(ross) + Number(ross_stats_count);
    if (rossForView === 0 || Number.isNaN(rossForView)) {
      return null;
    }

    return (
      <React.Fragment>
        {this.state.showTooltip && (
          <div className="tooltip_union_stat_match" ref={this.tooltipRef}>
            <div className="tooltip_union_stat_match_title">{getLang('ALL_BETS_IN_A_PLACE')}</div>
            <div className="tooltip_union_stat_match_content">{getLang('WE_GROUP_BET_WITH_STATISTICS')}</div>
            <div className="rectangle" />
            <div className="close" onClick={this.handleClose} />
          </div>)}
        <span className="g-t-a" onClick={this.rossToogle}>{(sr ? '-' : '+') + rossForView}</span>
      </React.Fragment>
    );
  }
}

const Score = ({text}) => (
  text ? <div className="g-score" dangerouslySetInnerHTML={{ __html: text }}></div> : null
);

@inject('lineStore', 'accountStore')
@observer
class Bet extends Component {

  componentDidUpdate (prevProps) {
    if (this.props.type == 'cf' && prevProps.cf && this.props.accountStore.accountSettings.highlightChangesLive && this.props.lineStore.mode == 'live') {
      if (prevProps.cf != this.props.cf) {
        prevProps.cf < this.props.cf ? this.animate('b-green') : this.animate('b-orange');
      }
    }
  }

  animate = (a) => {
    if (this.cell) {
      this.cell.classList.add(a);
      setTimeout(() => {
        if (this.cell) this.cell.classList.remove('b-green', 'b-orange');
      }, 2500);
    }
  };

  doBet = () => {
    const {mode} = this.props.lineStore.line;
    if (mode === 'line') {
      localStorage.setItem('lastAction', 1);
    } else {
      localStorage.setItem('lastAction', 0);
    }

    this.props.lineStore.basket.newAddOdd(this.props.oddKey, this.props.gid);
  };

  render () {
    const {type, cf, status, gid, id,oddKey} = this.props;
    let select = 0;
    // if(this.props.lineStore.basket.odds.has(gid))  console.log(this.props.lineStore.basket.odds.get(gid).id, id);
    if (this.props.lineStore.basket.basketData.oddsIds.has(oddKey)) {
      select = 1;
    };
    
    if (type == 'cf') {
      return (!status ? <td className={ type } ref={ el => {
        this.cell = el;
      } }><a className={ `g-b ${ select ? 'g-b-s' : '' }` } onClick={ this.doBet }
             dangerouslySetInnerHTML={ {__html: numberFormat(cf, 2, ',', ' ')} }></a></td> : <td className={ type }><span className="g-b-b"
                                                                                                                          dangerouslySetInnerHTML={ {__html: numberFormat(cf, 2, ',', ' ')} }></span>
      </td>);
    } else {
      return <td className="cf" dangerouslySetInnerHTML={ {__html: cf} }></td>;
    }
  }
}

const DopItems = ({id}) => [
  <FirstLineDop key={`FirstLineDop_${id}`} id={ id }/>,
  <TableDop key={`TableDop_${id}`} id={ id }/>
];

const HeaderItem = ({item}) => (
  <th className="line-table__col">
    <div className="line-table__col-inner">{ item.n }</div>
  </th>
);

class Header extends Component {
  shouldComponentUpdate (nextProps) {
    return (this.props.header && nextProps.header && this.props.header.join('') != nextProps.header.join(''));
  }

  renderTh = () => (
    this.props.header.map(item => (
      <HeaderItem key={ item.n } item={ item }/>
    ))
  );

  render () {
    return (
      this.props.header ?
        <tr className="l-t-h-tr-1 h-tr ">
          <th>Событие</th>
          { this.renderTh() }
          <th className="l-t-a-td"></th>
        </tr>
        : null
    );
  }
}

const LoaderRoss = () => (
  <tr>
    <td colSpan="21">
      <div className="loader-ross"></div>
    </td>
  </tr>
);

@withRouter
@inject('accountStore', 'appStore', 'lineStore', 'igStore')
@observer
export class LineTableEvent extends Component {

  componentDidMount() {
    const { type, games } = this.props.lineStore.line.selected;

    if (type === 3) {
      const game = this.props.lineStore.line.lineGames.get(this.props.id);
      this.props.igStore.setGame(toJS(game), null);
    }

    const gameId = getIdFromSlug(this.props.match.params.games);
    const Match = this.props.lineStore.line.lineGames.get(Number(gameId));
    const isStatisticMatch = Match && Match.parent_game_id;

    if (games.length === 1 && isStatisticMatch) {
      this.props.appStore.setNotificationVisibility('movingStatistics', true);
    }
  }

  renderBets = () => {
    const bets = this.props.lineStore.line.lineGames.get(this.props.id).f_l;
    return (
      bets.map((item, idx) => {
        return <Bet oddKey={item.oddKey} id={ item.id } key={ `${item.id}_${idx}` } cf={ item.h } gid={ this.props.id } type={ item.t } status={ item.st }/>;
      })
    );
  };

  handleSelect = () => {
    const {mode} = this.props.lineStore.line;
    if (mode === 'line') {
      localStorage.setItem('lastAction', 1);
    } else {
      localStorage.setItem('lastAction', 0);
    }

    this.props.history.push(`/${ this.props.lineStore.line.mode }/${ this.props.lineStore.line.lineGames.get(this.props.id).sid }/${ this.props.lineStore.line.lineGames.get(this.props.id).lid }/${ this.props.id }`);
    // this.props.lineStore.line.selectGame(this.props.id);
  };

  render () {
    const {id, date, c1, c2, ross, number, lid, score, sr, info, hd, tv, video_type, video, stats} = this.props.lineStore.line.lineGames.get(this.props.id);
    const { score: openTabGameScore, id: openTabGameId } = this.props.igStore.game || {};
    // Если игра есть в WS, открыта текстовая трансляция игры и id игр из трансляции и лаива совпадают, то в лаиве показываем score из текстовой трансляции
    const isGameNotWsAndIdExistAndEqual = openTabGameId === id;
    const preparedScore = isGameNotWsAndIdExistAndEqual ? openTabGameScore : score;
    const count = this.props.lineStore.line.countSelectGames;
    const game = toJS(this.props.lineStore.line.lineGames.get(this.props.id));
    const header = count == 1 ? hd : this.props.lineStore.line.lineGames.get(this.props.lineStore.line.lineLeague.get(lid).games[0]).hd;
    const mode = this.props.lineStore.line.mode == 'line';
    const loadedDop = this.props.lineStore.line.lineGamesDetails.has(this.props.id);
    const loadingRoss = this.props.lineStore.line.loadingRoss.find(v => v == this.props.id);
    const is_video = video_type && video_type.length && video_type[0];
    const videoPlaying = this.props.igStore.video.playing && this.props.igStore.video.gid === id;
    return (
      <Fragment>
        { mode && header && (count == 1 || this.props.idx == 0) ? <Header header={ header }/> : null }
        <tr className="g-tr">
          <td className="g-d-td">
            <div className="clearfix">
              <NumberGames number={ number } mode={ mode }/>
              <div className="g-f">
                { !mode ? <FavouriteStar type={ 3 } id={ this.props.id }/> : '' }
              </div>
                  <div className="g-date">{date}</div>
                <b
                  className={`g-d ${parseInt(ross) !== 0 ? 'g-d-s' : ''}`}
                  onClick={parseInt(ross) ? this.handleSelect : () => { }}>
                    <span>
                      {c1} {c2 ? ` - ${c2}` : ''}
                    </span>
                </b>
              { info ? <div className="g-info">{info}</div> : '' }
              { tv ? <Tv data={ tv }/> : '' }
              {is_video
                ? video_type.map(type => (
                  <div key={`${type}`} className="g-tv fl_r">
                          <span
                            className={`item-ico-video${
                              videoPlaying ? ' item-ico-video-playing' : ''
                            } item-ico-video-type-${video[0].type}`}
                            onClick={() => this.props.igStore.setGame(game, 'video')}
                          />
                  </div>
                ))
                : null}
              {stats ? (
                <div className="g-tv fl_r">
                      <span
                        className="f-s-ico-infographics"
                        onClick={() => this.props.igStore.setGame(game, 'events')}
                      />
                </div>
              ) : (
                ''
              )}
                  <Score text={preparedScore} />
            </div>
          </td>
          {this.renderBets()}
          <td className="g-t-a-td">
            { parseInt(ross) ? <Toogle id={ id } showTooltip={game.showTooltip && this.props.accountStore.accountSettings.tooltip_union_stat_match === 0 }/> : null }
          </td>
        </tr>
        { sr && !loadingRoss ? <DopItems key={ `dopItem_${lid}_${this.props.id}` } id={ this.props.id }/> : null }
        { loadingRoss ? <LoaderRoss/> : null }
        { mode && sr && (this.props.idx + 1 != this.props.lg) && loadedDop ? <Header header={ header }/> : null }
      </Fragment>
    );
  }
}

@inject('lineStore')
@observer
export class FirstLineDop extends Component {

  renderBets = (idx) => {
    const bets = this.props.lineStore.line.firstLine.get(this.props.id)[idx];
    return (
      <Fragment>
        <td>{ bets[0].h }</td>
        { bets.slice(1).map(item => (<Bet oddKey={item.oddKey} key={ item.id } cf={ item.h } type={ item.t } id={ item.id } status={ item.st } gid={ this.props.id }/>)) }
        <td></td>
      </Fragment>
    );
  };

  renderRow = () => {
    let result = [];
    const rows = this.props.lineStore.line.firstLine.get(this.props.id);

    rows.map((item, idx) => {
      result.push(
        <tr className="g-tr" key={ idx }>
          { this.renderBets(idx) }
        </tr>
      );
    });

    return result;
  };
  render () {
    const lineStore = this.props.lineStore.line;
    const firstBet = lineStore.firstLine.get(this.props.id);
    return firstBet ? this.renderRow() : null;
  }
}

const Tv = ({data}) => (
  <div className="g-tv fl_r"><span className="f-s-ico-tv"></span>
    <div className="channels">
      { data.map((el, idx) =>
        <span key={ el } className="channel">{ el }</span>
      ) }
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/line/lineTableEvent.js